import axios from 'axios'
import httpBuilder from './httpBuilder.js'
import { eventHub } from "@/libs/eventhub";
import moment from 'moment';

const encStr = () => {
    const CryptoJS = require('crypto-js');
    const message = `${moment().unix()}`
    const key = process.env.VUE_APP_SSC_KEY

    const encrypted = CryptoJS.AES.encrypt(message, CryptoJS.enc.Utf8.parse(key), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString();
};

const baseClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL
});

let defaultLang = localStorage.getItem('_lang') || 'vi'

baseClient.interceptors.request.use(
    function (config) {
        let sct = localStorage.getItem('_sit')
        config.headers["Authorization"] = `Bearer ${sct}`
        config.headers["ses"] = encStr()
        config.headers["ctz"] = Intl.DateTimeFormat().resolvedOptions().timeZone,
        config.headers["accept-language"] = defaultLang
        eventHub.$emit('isLoading')
        return config;
    },
    function (error) {
        eventHub.$emit('isLoading')
        return Promise.reject(error);
    }
);

baseClient.interceptors.response.use(
    response => {
        eventHub.$root.$emit('endLoading')
        return response;
    },
    error => {
        eventHub.$root.$emit('endLoading')
        return Promise.reject(error);
    }
);

export const httpClient = httpBuilder(baseClient)
